var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{class:_vm.$vuetify.theme.dark ? undefined : 'grey lighten-3',attrs:{"id":"pages"}},[_c('v-img',{class:{
      'v-image--sm': this.$vuetify.breakpoint.smAndDown,
      'v-image--md': this.$vuetify.breakpoint.mdAndDown
    },attrs:{"src":require(("@/assets/" + (_vm.src || 'login.jpg')))}},[_c('v-responsive',{staticClass:"d-flex align-center",style:(_vm.styles)},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }